/**
 * @fileoverview Defines the `SparsePath` type (string or object with path and allowed subpaths) and related utilities. Includes functions like `baseOfSparsePath` to extract the base path and `readSparsePath` to get the full `PathWithAllowedSubPaths` object. Also provides `hashSparsePath` to generate a hash of the sparse path.
 */

import crypto from 'crypto'

export type PathWithAllowedSubPaths = {
  path: string
  allowedSubPaths?: string[]
}

export type SparsePath = string | PathWithAllowedSubPaths

export function baseOfSparsePath(sparsePath: SparsePath): string {
  return typeof sparsePath === 'string' ? sparsePath : sparsePath.path
}

export function readSparsePath(sparsePath: SparsePath): PathWithAllowedSubPaths {
  return typeof sparsePath === 'string' ? { path: sparsePath } : sparsePath
}

export function hashSparsePath(sparsePath: SparsePath): string {
  const { path, allowedSubPaths } = readSparsePath(sparsePath)
  const hash = crypto.createHash('sha256')
  hash.update(`${path}:${allowedSubPaths?.join(',')}`)
  return hash.digest('hex')
}
